import request from '@/config/axios'

export const getCircleContentPage = (params: any) =>
  request.get({ url: '/bosscircle/circle-content/page', params })
export const createCircleContent = (data: any) =>
  request.post({ url: '/bosscircle/circle-content/create', data })
export const updateCircleContent = (data: any) =>
  request.put({ url: '/bosscircle/circle-content/update', data })
export const publishCircleContent = (data: any) =>
  request.put({ url: '/bosscircle/circle-content/publish', data })
